var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:this.type,style:(_vm.customStyles),on:{"click":function($event){return _vm.clicked()}}},[_c('div',{staticClass:"wrapper"},[(typeof _vm.icon !== 'undefined' && _vm.icon !== '')?_c('span',{class:['icon', _vm.icon]}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }